import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { print } from 'graphql/language/printer';
import * as i1 from '@angular/common/http';

class BaseModel {
    constructor(...args) {
    }
}

function Model(root, aliases) {
    return function _Model(constr) {
        BaseModel.constructors || (BaseModel.constructors = {});
        BaseModel.constructors[constr.name] = constr;
        aliases || (aliases = []);
        BaseModel.models || (BaseModel.models = []);
        BaseModel.models.push({ name: constr.name, root: root, aliases: aliases });
        return class extends constr {
            constructor(...args) {
                super(...args);
                this.root = root;
                this.className = constr.name;
            }
        };
    };
}

function Column(options) {
    return (target, propertyKey) => {
        // console.log(target, propertyKey)
        target.columns || (target.columns = []);
        const column = { property: propertyKey, column: propertyKey };
        if (typeof options !== 'undefined') {
            if (options.column) {
                column['column'] = options.column;
            }
            if (options.model) {
                column['model'] = options.model;
            }
        }
        target.columns.push(column);
    };
}

let Pagination = class Pagination extends BaseModel {
};
__decorate([
    Column()
], Pagination.prototype, "totalPages", void 0);
__decorate([
    Column()
], Pagination.prototype, "totalEntries", void 0);
__decorate([
    Column()
], Pagination.prototype, "currentPage", void 0);
__decorate([
    Column()
], Pagination.prototype, "perPage", void 0);
__decorate([
    Column()
], Pagination.prototype, "previousPage", void 0);
__decorate([
    Column()
], Pagination.prototype, "nextPage", void 0);
Pagination = __decorate([
    Model('pagination')
], Pagination);

class GraphqlService {
    constructor(http) {
        this.http = http;
        this.baseUrl = '';
    }
    findAll(query, variables) {
        return this.query({ query: query, variables: variables });
    }
    find(query, variables) {
        return this.query({ query: query, variables: variables });
    }
    push(mutate, variables) {
        return this.mutate({ query: mutate, variables: variables });
    }
    query(options) {
        if (this.instanceOfDocumentNode(options.query)) {
            // convert DocumentNode in a string representation of our query
            options.query = print(options.query);
        }
        return this.http
            .post(this.baseUrl, Object.assign({}, options))
            .pipe(map((d) => this.toModel(d)));
    }
    mutate(options) {
        if (this.instanceOfDocumentNode(options.query)) {
            options.query = print(options.query);
        }
        return this.http
            .post(this.baseUrl, Object.assign({}, options))
            .pipe(map((d) => this.toModel(d)));
    }
    addTypename(query) {
        if (this.instanceOfDocumentNode(query)) {
            // console.dir(query)
            // console.log(query)
        }
        return query;
    }
    toModel(d, model) {
        if (Object.keys(d).length === 2 && d.errors) {
            d.errors.forEach((error) => {
                console.error(error.message, error.location);
            });
            throw d;
        }
        model || (model = this.detectModel(d.data));
        const pagination = this.extractPagination(d.data);
        if (pagination) {
            this.lastPagination = pagination;
        }
        if (typeof model === 'undefined') {
            console.log('no model found for', d.data);
            return;
        }
        // @ts-ignore
        if (d.data[model.detectedRoot] === null) {
            return;
        }
        if (model && typeof (model === null || model === void 0 ? void 0 : model.detectedRoot) !== 'undefined') {
            if (typeof d.data[model === null || model === void 0 ? void 0 : model.detectedRoot].map === 'function') { // array
                return d.data[model === null || model === void 0 ? void 0 : model.detectedRoot].map((con) => {
                    if (model) {
                        return this.extractModel(model, con);
                    }
                });
            }
            else { // single item
                const con = d.data[model === null || model === void 0 ? void 0 : model.detectedRoot];
                return this.extractModel(model, con);
            }
        }
    }
    extractModel(model, data) {
        if (model) {
            const obj = new BaseModel.constructors[model.name]();
            obj.columns.forEach((column) => {
                if (column.property) {
                    if (typeof data[column.column] === 'object' && data[column.column] !== null && !this.isArrayOfStrings(data[column.column])) {
                        const fake = {};
                        fake[column.model || column.column] = data[column.column];
                        const subModel = this.detectModel(fake);
                        if (typeof subModel !== 'undefined' && subModel.detectedRoot) {
                            obj[column.property] = this.toModel({ data: fake }, subModel);
                        }
                        else if (typeof subModel === 'undefined') {
                            console.error('No Model detected for', column.property, fake);
                        }
                        else {
                            console.error('Column', column.property, 'can not be assigned ', fake, subModel);
                        }
                    }
                    else {
                        obj[column.property] = data[column.column];
                    }
                }
            });
            return obj;
        }
    }
    detectModel(data) {
        if (typeof data === 'undefined') {
            return;
        }
        return Object.keys(data).map((key) => {
            const model = BaseModel.models.find((model) => model.root === key || model.aliases.indexOf(key) > -1);
            if (model) {
                if (model.root === key) {
                    model.detectedRoot = key;
                    return model;
                }
                else {
                    let alias = model.aliases.find((_alias) => _alias === key);
                    if (alias) {
                        model.detectedRoot = alias;
                        return model;
                    }
                }
            }
            return undefined;
        })[0];
    }
    extractPagination(data) {
        if (typeof data === 'undefined') {
            return;
        }
        const key = Object.keys(data).find((k) => k === 'pagination');
        if (!key) {
            return;
        }
        const model = BaseModel.models.find((model) => model.root === key || model.aliases.indexOf(key) > -1);
        if (!model) {
            return;
        }
        return this.extractModel(model, data[key]);
    }
    instanceOfDocumentNode(object) {
        if (object instanceof String) {
            return false;
        }
        return object.kind === 'Document';
    }
    isArrayOfStrings(array) {
        try {
            return !array.find((item) => {
                return typeof item !== 'string';
            });
        }
        catch (e) {
            return false;
        }
    }
}
GraphqlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GraphqlService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
GraphqlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GraphqlService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GraphqlService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

/*
 * Public API Surface of scf-graphql-model
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BaseModel, Column, GraphqlService, Model, Pagination };
